import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { RoleFacade } from '@cdba/core/auth/role-facade/role.facade';
import { BetaFeature } from '@cdba/shared/constants/beta-feature';

import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class BetaFeatureService {
  private readonly localStorageService = inject(LocalStorageService);
  private readonly roleFacade = inject(RoleFacade);

  private readonly storageKeyPrefix = 'betaFeature';

  getBetaFeature(key: `${BetaFeature}`): boolean | undefined {
    return (
      this.localStorageService.getItem<boolean>(
        `${this.storageKeyPrefix}_${key}`,
        true
      ) ?? false
    );
  }

  setBetaFeature(key: `${BetaFeature}`, betaFeatureState: boolean): void {
    this.localStorageService.setItem(
      `${this.storageKeyPrefix}_${key}`,
      betaFeatureState,
      false
    );
  }

  canAccessBetaFeature$(
    betaFeature: BetaFeature
  ): Observable<boolean | undefined> {
    const isBetaFeatureEnabled = this.getBetaFeature(betaFeature);

    return this.roleFacade.hasBetaUserRole$.pipe(
      map((hasBetaUserRole) => hasBetaUserRole && isBetaFeatureEnabled)
    );
  }
}
